'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);


var _RocketPackages = require('./RocketPackages.scss');var styles = _interopRequireWildcard(_RocketPackages);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PackageMobile = function PackageMobile(props) {
  var handleClickPackedge = function handleClickPackedge() {return props.changeSelectedPackage(props.packageInstance.id);};

  var handleBuy = function handleBuy() {var
    packageInstance = props.packageInstance,handleChoosePackage = props.handleChoosePackage;
    handleChoosePackage(packageInstance);
  };

  var renderMostPopular = function renderMostPopular() {var
    packageInstance = props.packageInstance;
    var mostPopular = (0, _get2.default)(packageInstance, 'mostPopular', false);

    if (mostPopular) {
      return (
        _react2.default.createElement('div', { className: styles.mostPopularWrapper },
          _react2.default.createElement('p', { className: styles.mostPopular },
            props.translate('mostPopular'))));



    }

    return null;
  };

  var renderTopBlock = function renderTopBlock() {var _cx;var _props$packageInstanc =
    props.packageInstance,packageInstance = _props$packageInstanc === undefined ? {} : _props$packageInstanc;
    var periods = (0, _get2.default)(packageInstance, 'periods', 0);
    var perDay = (0, _get2.default)(packageInstance, 'period.' + packageInstance.periods + '.perDay', 0);

    return (
      _react2.default.createElement('div', { className: styles.topBlock },
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', {
            className: (0, _classnames2.default)(styles.circle, (_cx = {}, _cx[
            styles.circleBlue] = props.selectedPackage === props.packageInstance.id, _cx)) }),


          _react2.default.createElement('p', { className: styles.periods }, periods),
          _react2.default.createElement('p', { className: styles.days },
            props.translate('days'))),


        _react2.default.createElement('div', null,
          renderMostPopular(),
          _react2.default.createElement('div', { className: styles.perDay }, '\u20AA',
            perDay, ' ', props.translate('perDay')))));




  };

  var renderPriceBlock = function renderPriceBlock() {var _props$packageInstanc2 =
    props.packageInstance,packageInstance = _props$packageInstanc2 === undefined ? {} : _props$packageInstanc2;
    var price = (0, _get2.default)(packageInstance, 'period.' + packageInstance.periods + '.price', 0);

    return (
      _react2.default.createElement('div', { className: styles.priceBlock },
        _react2.default.createElement('div', { className: styles.priceWrapper },
          _react2.default.createElement('p', { className: styles.cost },
            props.translate('price')),

          _react2.default.createElement('p', { className: styles.price }, '\u20AA',
            price)),


        _react2.default.createElement('button', {
            className: styles.actionButton,
            onClick: handleBuy },

          props.translate('buy'))));



  };

  return (
    _react2.default.createElement('div', { className: styles.questionPackageMobileWrapper, onClick: handleClickPackedge },
      renderTopBlock(),
      props.selectedPackage === props.packageInstance.id && renderPriceBlock()));


}; // styles

PackageMobile.propTypes = {
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  packageInstance: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  handleChoosePackage: _propTypes2.default.func,
  changeSelectedPackage: _propTypes2.default.func,
  selectedPackage: _propTypes2.default.string };exports.default =


PackageMobile;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RocketPackages/PackedgeMobile.js
// module id = 2849
// module chunks = 0